// Figma: 6086:28468 — see stories/blocks/trusted-customers-grid-expanded-card.stories.tsx
"use client";

import { ArrowUpRight } from "iconoir-react";

import { Link } from "@/components/ui/link";

import type { CustomerShortCard } from "./customers-grid-data";

interface TrustedCustomersGridExpandedCardProps {
  name: string;
  shortCard: CustomerShortCard;
  /** Case-study href — omitted for brands with no live story page. */
  caseStudyHref?: string | null;
}

export function TrustedCustomersGridExpandedCard({
  name,
  shortCard,
  caseStudyHref,
}: TrustedCustomersGridExpandedCardProps) {
  return (
    <div className="bg-grey-950 text-grey-0 relative flex h-full w-full items-start overflow-hidden rounded-2xl p-4">
      {shortCard.bgSrc ? (
        <>
          <img
            src={shortCard.bgSrc}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div
            aria-hidden
            className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-black/50"
          />
        </>
      ) : null}
      {caseStudyHref ? (
        <Link
          href={caseStudyHref}
          aria-label={`Read the ${name} customer story`}
          className="border-grey-0/20 bg-grey-0/12 hover:border-grey-0/35 hover:bg-grey-0/25 animate-in fade-in-0 zoom-in-95 group absolute top-2.5 right-2.5 z-10 flex size-7 items-center justify-center rounded-full border backdrop-blur-[2px] transition-colors duration-200 ease-out motion-reduce:animate-none"
          data-testid="trusted-customers-grid-case-study-link"
          data-ph-capture-attribute-cta_label={`Trusted Customers Grid - ${name} case study`}
          data-ph-capture-attribute-cta_url={caseStudyHref}
        >
          <ArrowUpRight
            className="text-grey-0/65 group-hover:text-grey-0 size-3 transition-[transform,color] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 motion-reduce:transition-none"
            strokeWidth={2}
          />
        </Link>
      ) : null}
      <div className="relative flex max-w-[190px] flex-col items-start gap-1">
        <p className="text-ds-display-sm leading-[1.1] tracking-[-0.04em]">
          {shortCard.stat}
        </p>
        {shortCard.label ? (
          <p className="text-ds-body-sm leading-[1.5] tracking-[-0.02em]">
            {shortCard.label}
          </p>
        ) : null}
      </div>
    </div>
  );
}
